import { render, staticRenderFns } from "./AppBarNotification.vue?vue&type=template&id=814b5f18"
import script from "./AppBarNotification.vue?vue&type=script&lang=js"
export * from "./AppBarNotification.vue?vue&type=script&lang=js"
import style0 from "./AppBarNotification.vue?vue&type=style&index=0&id=814b5f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports